import PageMeta from "../../../../shared/ui/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignInForm from "../components/SignInForm";

export default function SignIn() {
  return (
    <>
      <PageMeta/>
      <AuthLayout>
        <SignInForm />
      </AuthLayout>
    </>
  );
}
